<template>
  <div class="text-center my-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ hiddenText }}</span>
    </div>
    <p class="mt-2">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    message: {
      type: String,
      default: 'جاري تحميل البيانات...'
    },
    hiddenText: {
      type: String,
      default: 'جاري التحميل...'
    }
  }
}
</script>